import React, { useEffect, useState } from "react";
import { Link } from "~/components/Elements";
import "./VolbyPrezident2024.css";
const urlAllInfo = "https://www.teraz.sk/prezidentske-volby-2024";
const urlCandidatesInfo = "https://www.teraz.sk/kandidatne-listiny-volbynrsr23";
const urlElectionResults = "https://www.teraz.sk/volby-2024";

const svec_url = "https://www.teraz.sk/najnovsie/profil-roberta-sveca/779327-clanok.html?utm_source=teraz&utm_medium=organic&utm_campaign=click&utm_content=.%253BsNajnov%25C5%25A1ie";
const pellegrini_url = "https://www.teraz.sk/najnovsie/profil-petra-pellegriniho/779326-clanok.html?utm_source=teraz&utm_medium=organic&utm_campaign=click&utm_content=.%253BsNajnov%25C5%25A1ie";
const nahlik_url = "https://www.teraz.sk/najnovsie/profil-milana-nahlika/779325-clanok.html?utm_source=teraz&utm_medium=organic&utm_campaign=click&utm_content=.%253BsNajnov%25C5%25A1ie";
const matovic_url = "https://www.teraz.sk/najnovsie/profil-igora-matovica/779323-clanok.html?utm_source=teraz&utm_medium=organic&utm_campaign=click&utm_content=.%253BsNajnov%25C5%25A1ie";
const kubis_url = "https://www.teraz.sk/najnovsie/profil-jana-kubisa/779322-clanok.html?utm_source=teraz&utm_medium=organic&utm_campaign=click&utm_content=.%253BsNajnov%25C5%25A1ie";
const kotleba_url = "https://www.teraz.sk/najnovsie/profil-mariana-kotlebu/779321-clanok.html?utm_source=teraz&utm_medium=organic&utm_campaign=click&utm_content=.%253BsNajnov%25C5%25A1ie";
const korcok_url = "https://www.teraz.sk/najnovsie/profil-ivana-korcoka/779319-clanok.html?utm_source=teraz&utm_medium=organic&utm_campaign=click&utm_content=.%253BsNajnov%25C5%25A1ie";
const harabin_url = "https://www.teraz.sk/najnovsie/profil-stefana-harabina/779318-clanok.html?utm_source=teraz&utm_medium=organic&utm_campaign=click&utm_content=.%253BsNajnov%25C5%25A1ie";
const forro_url = "https://www.teraz.sk/najnovsie/profil-krisztiana-forroa/779316-clanok.html?utm_source=teraz&utm_medium=organic&utm_campaign=click&utm_content=.%253BsNajnov%25C5%25A1ie";
const dubovsky_url = "https://www.teraz.sk/najnovsie/profil-patrika-dubovskeho/779315-clanok.html?utm_source=teraz&utm_medium=organic&utm_campaign=click&utm_content=.%253BsNajnov%25C5%25A1ie";
const danko_url = "https://www.teraz.sk/najnovsie/profil-andreja-danka/779311-clanok.html?utm_source=teraz&utm_medium=organic&utm_campaign=click&utm_content=.%253BsNajnov%25C5%25A1ie";


const HeaderBanner = (props) => {
  
  var end = new Date('03/23/2024 07:00 AM');
  const [showInfo, setShowInfo] = useState(true);
  const [showCounter, setShowCounter] = useState(false);  
  var timer;

  useEffect(() => {   
    const now = new Date();
    const startElections = new Date('03/23/2024 07:00 AM');
    const endElections = new Date('03/23/2024 10:00 PM');
    if(Date.parse(now) > Date.parse(startElections)){      
        if (timer) {
          clearInterval(timer);                    
        }        
        end = new Date('03/23/2024 10:00 PM');
        setShowInfo(true);
    }
  
    var _second = 1000;
    var _minute = _second * 60;
    var _hour = _minute * 60;
    var _day = _hour * 24;    
    function showRemaining() {
        var _now = new Date();
        var distance = end - _now;
        if (distance < 0) {
            clearInterval(timer);
            return;
        }
        var days = Math.floor(distance / _day).toString();
        var hours = Math.floor((distance % _day) / _hour).toString();
        var minutes = Math.floor((distance % _hour) / _minute).toString();
        var seconds = Math.floor((distance % _minute) / _second).toString();
        if (typeof document !== 'undefined' && document.querySelector('.hours') != null) {
          document.querySelector('.days').innerHTML = ("0" + days).slice(-2);
          document.querySelector('.hours').innerHTML = ("0" + hours).slice(-2);
          document.querySelector('.minutes').innerHTML = ("0" + minutes).slice(-2);
          document.querySelector('.seconds').innerHTML = ("0" + seconds).slice(-2);
      }      
    }

    timer = setInterval(showRemaining, 1000);
    // showCounter = true;
    setShowCounter(true);



  },[]);

  return (
    <div>
      <div className="bannerBase referendum-fullWidth">
            <div className="bannerBase-inner referendum-inner elections">
              <div className="top">
              <div className="countdownWrapper-text">
                {showInfo &&
                  <div className="countdownInfo">Do otvorenia volebných miestností ostáva:</div>
                }
                <div className="bannerCountdownWrapper" style={{ visibility: showCounter ? 'visible' : 'hidden' }}>
                  <div>
                    <div className="label">Dni</div>
                    <div className="days val">00</div>
                  </div>                  
                  <div className="sep">:</div>
                  <div>
                    <div className="label">Hodiny</div>
                    <div className="hours val">00</div>
                  </div>                  
                  <div className="sep">:</div>
                  <div>
                    <div className="label">Minúty</div>
                    <div className="minutes val">00</div>
                  </div>                  
                  <div className="sep">:</div>
                  <div>
                    <div className="label">Sekundy</div>
                    <div className="seconds val">00</div>
                  </div>                  
                </div>
              </div>                

                <div className="bannerBase-elections-title-wrapper">
                  <span>Prezidentské<br />voľby 2024</span>
                </div>

                <div className="actions">
                  <Link to={urlElectionResults}>
                    <div className="bannerBase-referendum-btn red-border no-margin">Vstup na volebnú stránku</div>
                  </Link>
                  <Link to={urlAllInfo}>
                    <div className="bannerBase-referendum-btn no-margin">Všetko o voľbách</div>
                  </Link>
                </div>

              </div>              
                
                <div className="candidates-list">
                  <Link to={danko_url}>
                    <div className="candidate c01">
                      <div className="photo"></div>
                      <div className="name">Andrej<br />Danko</div>
                    </div>
                  </Link>

                  <Link to={dubovsky_url}>
                  <div className="candidate c02">
                    <div className="photo"></div>
                    <div className="name">Patrik<br />Dubovský</div>
                  </div>
                  </Link>

                  <Link to={forro_url}>
                  <div className="candidate c03">
                    <div className="photo"></div>
                    <div className="name">Krisztián<br />Forró</div>
                  </div>
                  </Link>
                  
                  <Link to={harabin_url}>
                    <div className="candidate c04">
                      <div className="photo"></div>
                      <div className="name">Štefan<br />Harabin</div>
                    </div>
                  </Link>

                  <Link to={korcok_url}>
                    <div className="candidate c05">
                      <div className="photo"></div>
                      <div className="name">Ivan<br />Korčok</div>
                    </div>
                  </Link>

                  <Link to={kotleba_url}>
                    <div className="candidate c06">
                      <div className="photo"></div>
                      <div className="name">Marian<br />Kotleba</div>
                    </div>
                  </Link>

                  <Link to={kubis_url}>
                    <div className="candidate c07">
                      <div className="photo"></div>
                      <div className="name">Ján<br />Kubiš</div>
                    </div>
                  </Link>

                  <Link to={matovic_url}>
                  <div className="candidate c08">
                    <div className="photo"></div>
                    <div className="name">Igor<br />Matovič</div>
                  </div>
                  </Link>

                  <Link to={nahlik_url}>
                  <div className="candidate c09">
                    <div className="photo"></div>
                    <div className="name">Milan<br />Náhlik</div>
                  </div>
                  </Link>

                  <Link to={pellegrini_url}>
                  <div className="candidate c10">
                    <div className="photo"></div>
                    <div className="name">Peter<br />Pellegrini</div>
                  </div>
                  </Link>
                  
                  <Link to={svec_url}>
                  <div className="candidate c11">
                    <div className="photo"></div>
                    <div className="name">Róbert<br />Švec</div>
                  </div>
                  </Link>
                </div>

                {/* <Link className="fullAreaBtn" to={urlAllInfo}><div className="bannerBase-referendum-fullBtnArea"></div></Link>                 */}
            </div>
      </div>
    </div>
  );
};

export default HeaderBanner;
